import { generatePath, type Routes } from '@faceup/router'

export const routes: Record<keyof RoutesInterface, string> = {
  home: '/',
  createAdmin: '/create-admin',
  schools: '/schools',
  companies: '/companies',
  institution: '/institution/:id',
  reports: '/reports',
  report: '/report/:id',
  partners: '/partners',
  partner: '/partner/:id',
  materials: '/materials',
  globalTables: '/global-tables',
  hotlines: '/hotlines',
  vonageHotlines: '/vonage-hotlines',
  sendEmails: '/send-emails',
  aiHotlineSystemInstructions: '/ai-hotline-system-instructions',
}

export const useRoutes = (): Routes => ({
  home: () => generatePath(routes.home),
  createAdmin: () => generatePath(routes.createAdmin),
  schools: () => generatePath(routes.schools),
  companies: () => generatePath(routes.companies),
  institution: ({ id }) => generatePath(routes.institution, { id }),
  reports: () => generatePath(routes.reports),
  report: ({ id }) => generatePath(routes.report, { id }),
  partners: () => generatePath(routes.partners),
  partner: ({ id }) => generatePath(routes.partner, { id }),
  materials: () => generatePath(routes.materials),
  globalTables: () => generatePath(routes.globalTables),
  hotlines: () => generatePath(routes.hotlines),
  vonageHotlines: () => generatePath(routes.vonageHotlines),
  sendEmails: () => generatePath(routes.sendEmails),
  aiHotlineSystemInstructions: () => generatePath(routes.aiHotlineSystemInstructions),
})

interface RoutesInterface {
  home: RouteNoParams
  createAdmin: RouteNoParams
  schools: RouteNoParams
  companies: RouteNoParams
  institution: RouteWithParams<{ id: string }>
  reports: RouteNoParams
  report: RouteWithParams<{ id: string }>
  partners: RouteNoParams
  partner: RouteWithParams<{ id: string }>
  materials: RouteNoParams
  globalTables: RouteNoParams
  hotlines: RouteNoParams
  vonageHotlines: RouteNoParams
  sendEmails: RouteNoParams
  aiHotlineSystemInstructions: RouteNoParams
}

type RouteNoParams = () => string
type RouteWithParams<P> = (params: P) => string

declare module '@faceup/router' {
  export interface RoutesOverride extends RoutesInterface {}
}
